import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './styles/spinning-arcs.scss';

const SpinningArcs = (props) => {
    const { contextCls, baseDimension } = props;
    const style = {
        width: `${baseDimension}px`,
        height: `${baseDimension}px`,
    };

    return (
        <div className={cx('fluid-spinning-arcs', contextCls)} style={style} />
    );
};

SpinningArcs.defaultProps = {
    baseDimension: 200,
};

SpinningArcs.propTypes = {
    contextCls: PropTypes.string,
    baseDimension: PropTypes.number,
};

export default SpinningArcs;
